/** 标签栏历史页签菜单图标。 */
export function MenuSvgIcon() {
    return (
        <svg
            className="tabs-control-icon tabs-menu-svg-icon"
            width="24"
            height="24"
            viewBox="0 0 1024 1024"
            aria-hidden="true"
        >
            <path fill="currentColor" d="M768 352H256V288h512v64zM768 544H256v-64h512v64zM768 736H256v-64h512v64z" />
        </svg>
    );
}

export default MenuSvgIcon;
